import React, { useState, useEffect } from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, Container } from '@mui/material';
import Layout from './Layout';
import { GetApp, CloudUpload } from '@mui/icons-material';


const initialValue = {
    type: '',
    unit: '',
    source: {
        type: '',
        slave: 0,
        startBit: 0,
        endBit: 0,
    },
};

const initialSensor = {
    type: '',
    name: '',
    cron: '',
    values: [initialValue],
};

const initialFormState = {
    mode: 'standalone',
    tier: 'dev',
    mqtt_url: '',
    sensors: [initialSensor],
};

export const PhySenseConfig = () => {

    const [formData, setFormData] = useState(initialFormState);
    const [uploadedData, setUploadedData] = useState(null);


    const handleChange = (e, index, vIndex) => {

        const { name, value } = e.target;
        console.log(name, value, vIndex);

        if (name.startsWith('sensors')) {

            const [l1Field, l1FieldIndex, l2field, l2FieldIndex, l3Field, l4Field] = name.split('.')
            console.log(l1Field, l1FieldIndex, l2field, l2FieldIndex, l3Field, l4Field);


            setFormData((prevData) => ({
                ...prevData,
                sensors: prevData.sensors.map((sensor, i) =>
                    i === index
                        ? {
                            ...sensor,
                            [l2field]: l2field === 'values'
                                ? sensor[l2field].map((val, j) =>
                                    j === vIndex
                                        ? {
                                            ...val,
                                            [l3Field]: l3Field === 'source'
                                                ? {
                                                    ...val[l3Field],
                                                    [l4Field]: l4Field === 'startBit' || l4Field === 'endBit' || l4Field === 'slave'
                                                        ? parseInt(value) // Parse as integer for startBit and endBit
                                                        : value
                                                }
                                                : value
                                        }
                                        : val
                                )
                                : value,
                        }
                        : sensor
                ),
            }));
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };



    const handleAddSensor = () => {

        setFormData((prevData) => ({
            ...prevData,
            sensors: [...prevData.sensors, { ...initialSensor }],
        }));

    };

    const handleAddValue = (index) => {

        setFormData((prevData) => {
            const newValues = [...prevData.sensors[index].values, { ...initialValue }];
            const newSensors = [...prevData.sensors];
            newSensors[index].values = newValues;
            return { ...prevData, sensors: newSensors };
        });

    };

    const handleDownload = () => {

        let mqttUrl = '';
        if (formData.mode === 'standalone') {
            mqttUrl = formData.tier === 'dev' ? 'stream.dev.phyfarm.com' : 'stream.phyfarm.com';
        } else if (formData.mode === 'slave') {
            mqttUrl = formData.mqtt_url;
        }

        const updatedFormData = {
            ...formData,
            mqtt_url: mqttUrl
        };

        const jsonData = JSON.stringify(updatedFormData, null, 2);
        const blob = new Blob([jsonData], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'form_data.json';
        a.click();

    };

    const handleFileUpload = (event) => {

        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const uploadedFormData = JSON.parse(e.target.result);
                setUploadedData(uploadedFormData);
            } catch (error) {
                // Handle JSON parse error if necessary
                console.error('Error parsing uploaded JSON file:', error);
            }
        };

        reader.readAsText(file);
    };

    useEffect(() => {
        if (uploadedData) {
            setFormData((prevData) => ({ ...prevData, ...uploadedData }));
        }
    }, [uploadedData]);


    const handleSensorInfo = () => {
        const numSensors = formData.sensors.length;
        const sensorValuesInfo = formData.sensors.map((sensor, index) => `Sensor ${index + 1}: ${sensor.values.length}`);
        return (
            <>
                <div style={{ textAlign: 'left' }}>
                    <Typography variant="h7">Number of Sensors: {numSensors}</Typography>

                    <Typography >Values:</Typography>
                    {sensorValuesInfo.map((info, index) => (
                        <Typography key={index} variant="body1" style={{ marginLeft: '20px' }}>
                            {info}
                        </Typography>
                    ))}
                </div>
            </>
        );
    };

    const renderValueFields = (sensorIndex, valueIndex) => {

        const sourceType = formData.sensors[sensorIndex].values[valueIndex].source.type;
        const isLoraSource = sourceType === 'lora';

        return (
            <div>
                <div style={{ marginBottom: '8px' }}>
                    <TextField
                        label="Value Type"
                        fullWidth
                        name={`sensors.${sensorIndex}.values.${valueIndex}.type`}
                        value={formData.sensors[sensorIndex].values[valueIndex].type}
                        onChange={(e) => handleChange(e, sensorIndex, valueIndex)}
                    />
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <TextField
                        label="Unit"
                        fullWidth
                        name={`sensors.${sensorIndex}.values.${valueIndex}.unit`}
                        value={formData.sensors[sensorIndex].values[valueIndex].unit}
                        onChange={(e) => handleChange(e, sensorIndex, valueIndex)}
                    />
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor={`sensors.${sensorIndex}.values.${valueIndex}.source.type`}>
                            Source Type
                        </InputLabel>
                        <Select
                            id={`sensors.${sensorIndex}.values.${valueIndex}.source.type`}
                            name={`sensors.${sensorIndex}.values.${valueIndex}.source.type`}
                            value={formData.sensors[sensorIndex].values[valueIndex].source.type}
                            onChange={(e) => handleChange(e, sensorIndex, valueIndex)}
                        >
                            <MenuItem value="rs485">RS485</MenuItem>
                            <MenuItem value="lora">LoRa</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                {!isLoraSource && (
                    <div style={{ marginBottom: '8px' }}>
                        <TextField
                            label="Source Slave"
                            fullWidth
                            type="number"
                            name={`sensors.${sensorIndex}.values.${valueIndex}.source.slave`}
                            value={formData.sensors[sensorIndex].values[valueIndex].source.slave}
                            onChange={(e) => handleChange(e, sensorIndex, valueIndex)}
                        />
                    </div>
                )}
                <div style={{ marginBottom: '8px' }}>
                    <TextField
                        label="Source Start Bit"
                        fullWidth
                        type="number"
                        name={`sensors.${sensorIndex}.values.${valueIndex}.source.startBit`}
                        value={formData.sensors[sensorIndex].values[valueIndex].source.startBit}
                        onChange={(e) => handleChange(e, sensorIndex, valueIndex)}
                    />
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <TextField
                        label="Source End Bit"
                        fullWidth
                        type="number"
                        name={`sensors.${sensorIndex}.values.${valueIndex}.source.endBit`}
                        value={formData.sensors[sensorIndex].values[valueIndex].source.endBit}
                        onChange={(e) => handleChange(e, sensorIndex, valueIndex)}
                    />
                </div>
            </div>
        );
    };

    console.log(formData);
    const numSensorRows = Math.ceil(formData.sensors.length / 4);

    return (

        <Layout>
            <div style={{ textAlign: 'center', margin: '80px auto', maxWidth: 600 }}>

                <Typography variant="h5" style={{ marginBottom: 20, marginTop: 100 }}>
                    PhySense Config Builder
                </Typography>

                <div className="top-fields" style={{ display: 'flex', gap: '45px', alignItems: 'center' }}>

                    <div style={{ marginBottom: '8px', width: 300 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="mode">Mode</InputLabel>
                            <Select
                                id="mode"
                                name="mode"
                                value={formData.mode}
                                onChange={handleChange}
                            >
                                <MenuItem value="standalone">Standalone</MenuItem>
                                <MenuItem value="slave">Slave</MenuItem>
                            </Select>
                        </FormControl>

                        {formData.mode === 'standalone' && (
                            <div style={{ marginTop: 8 }}>
                                <div style={{ marginBottom: '8px' }}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="tier">Select Tier</InputLabel>
                                        <Select
                                            id="tier"
                                            name="tier"
                                            value={formData.tier}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="dev">Development</MenuItem>
                                            <MenuItem value="prod">Production</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div>
                                    <TextField
                                        label="MQTT URL"
                                        fullWidth
                                        disabled
                                        value={
                                            formData.tier === 'dev'
                                                ? 'stream.dev.phyfarm.com'
                                                : 'stream.phyfarm.com'
                                        }
                                    />
                                </div>
                            </div>
                        )}

                    </div>
                    <div style={{ width: 300 }}>
                        <Container maxWidth="sm" style={{ border: '1px solid #ccc', marginBottom: '16px', marginTop: '8px', borderRadius: 5, padding: '16px' }}>
                            <Typography variant='h5' style={{ marginBottom: '6px' }}>
                                PhySense Config Info
                            </Typography>
                            {handleSensorInfo()}
                        </Container>
                    </div>
                </div>

                {formData.mode === 'slave' && (
                    <div style={{ marginBottom: '8px' }}>
                        <TextField
                            label="MQTT URL"
                            fullWidth
                            name="mqtt_url"
                            value={formData.mqtt_url}
                            onChange={handleChange}
                        />
                    </div>
                )}

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                    {[...Array(numSensorRows)].map((_, rowIndex) => (

                        <div key={rowIndex} style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: 20 }}>

                            {formData.sensors.slice(rowIndex * 4, (rowIndex + 1) * 4).map((sensor, index) => (
                                <div key={index} style={{ border: '1px solid #ccc', marginBottom: '16px', marginTop: '16px', paddingLeft: 10, paddingRight: 10, flex: '1', margin: '20px', minWidth: '300px', borderRadius: 5 }}>
                                    {/* Add margin to create spacing between cards */}
                                    <h4>Sensor {rowIndex * 4 + index + 1}</h4>
                                    <div style={{ marginBottom: '8px' }}>
                                        <TextField
                                            label="Sensor Type"
                                            fullWidth
                                            name={`sensors.${rowIndex * 4 + index}.type`}
                                            value={sensor.type}
                                            onChange={(e) => handleChange(e, rowIndex * 4 + index)}
                                        />
                                    </div>
                                    <div style={{ marginBottom: '8px' }}>
                                        <TextField
                                            label="Sensor Name"
                                            fullWidth
                                            name={`sensors.${rowIndex * 4 + index}.name`}
                                            value={sensor.name}
                                            onChange={(e) => handleChange(e, rowIndex * 4 + index)}
                                        />
                                    </div>
                                    <div style={{ marginBottom: '8px' }}>
                                        <TextField
                                            label="Cron"
                                            fullWidth
                                            name={`sensors.${rowIndex * 4 + index}.cron`}
                                            value={sensor.cron}
                                            onChange={(e) => handleChange(e, rowIndex * 4 + index)}
                                        />
                                    </div>

                                    {sensor.values.map((value, vIndex) => (
                                        <div key={vIndex} style={{ marginBottom: '16px' }}>
                                            <h5>Value {vIndex + 1}</h5>
                                            {renderValueFields(rowIndex * 4 + index, vIndex)}
                                        </div>
                                    ))}

                                    <Button variant="contained" color="primary" onClick={() => handleAddValue(rowIndex * 4 + index)} style={{ marginBottom: 10 }}>
                                        Add Value
                                    </Button>
                                </div>
                            ))}
                        </div>
                    ))}

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <Button variant="contained"
                            color="primary"
                            onClick={handleAddSensor}
                            style={{ marginRight: 10 }}>
                            Add Sensor
                        </Button>


                        <Button
                            color="primary"
                            variant="contained"
                            component="label"
                            style={{ marginRight: 12, marginLeft: 12, backgroundColor: '#3f51b5', color: 'white' }}
                        > Upload JSON
                            <CloudUpload style={{ marginLeft: 10 }} />
                            <input type="file" hidden onChange={handleFileUpload} accept=".json" />
                        </Button>

                        <Button variant="contained"
                            color="primary"
                            onClick={handleDownload}
                            style={{ marginRight: 10 }}>
                            Download JSON
                            <GetApp style={{ marginLeft: 10 }} />
                        </Button>
                    </div>

                </div>
            </div>

        </Layout>
    );
};